import { getCMSPageDataByContentType } from 'src/cms/client'
import type { Builder } from 'src/cms/ClientCMS'

import { axiosClient } from '../../services/axiosInstance'

const CLUB_PAGE_CONTENT_TYPE = 'clube-page'
const BUILDER = 'cms-site-app'
const NAME = 'LP - Novo Clube'

type GetClubCmsDataProps = {
  versionId?: string
  pageId?: string
  fromServerSide?: boolean
}

export async function getClubeCMSPage({
  versionId = '',
  pageId = '',
  fromServerSide = true,
}: GetClubCmsDataProps) {
  try {
    if (fromServerSide) {
      return getCMSPageDataByContentType({
        contentType: CLUB_PAGE_CONTENT_TYPE,
        params: { filters: { name: NAME } },
        builder: BUILDER as Builder,
        pageId,
        versionId,
      })
    }

    return axiosClient.get(
      `/api/cms/getPageData?builder=${BUILDER}&contentType=${CLUB_PAGE_CONTENT_TYPE}&versionId=${versionId}&pageId=${pageId}&filters=${JSON.stringify(
        { name: NAME }
      )}`
    )
  } catch (error) {
    return null
  }
}
